import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import { DriverSummaryPanelComponent } from "./driverSummaryPanel/driverSummaryPanel.component";
import { JourneySummaryComponent } from "./journeySummary/journeySummary.component";
import { VehicleButtonFilterComponent } from "./vehicle-button-filter/vehicle-button-filter.component";
import { VehicleInfoCardComponent } from "./vehicleInfoCard/vehicleInfoCard.component";
import { VehicleListComponent } from "./vehicleList/vehicleList.component";
import { VehiclePlotTimeComponent } from "./vehiclePlotTime/vehiclePlotTime.component";
import { VehicleRegComponent } from "./vehicleReg/vehicleReg.component";
import { VVehicleVideoStreamComponent } from "./VehicleVideoStream/v-vehicle-video-stream.component";

angular
    .module("app.vehicle.directives", [])

    .directive("vehicleInfoCard", downgradeComponent({ component: VehicleInfoCardComponent }))
    .directive("vVehicleVideoStream", downgradeComponent({ component: VVehicleVideoStreamComponent }))
    .component("vehicleList", new VehicleListComponent())
    .directive("vehicleReg", downgradeComponent({ component: VehicleRegComponent }))
    .directive("vehiclePlotTime", downgradeComponent({ component: VehiclePlotTimeComponent }))

    .directive("driverSummaryPanel", downgradeComponent({ component: DriverSummaryPanelComponent }))

    .directive("vehicleListNew", downgradeComponent({ component: VehicleListComponent }))
    .directive("vehicleButtonFilter", downgradeComponent({ component: VehicleButtonFilterComponent }))

    .component("journeySummary", new JourneySummaryComponent())
    ;
